<template>
    <div class="recharge_wrap">
        <div class="title-box">
			<button class="back" @click="$router.go(-1)">
				<i class="iconfont icon-zuojiantou2"></i>
			</button>
			<h2>{{ $t('account.manage') }}</h2>
		</div>
        <div class="wrap_box warp1">
            <p><span>{{allNum}}</span> {{$t('account.withdrawalAccounts')}}</p>
        </div>
        <div class="wrap_box warp2">
            <div class="item" v-for="(i,j) in data.bank" :key="j" @click.stop="$router.push('/addcountUsdt?id='+i.id)">
                <img :src="require('../images/user/recharge'+i.type+'.png')" alt="">
                <div class="item_detail">
                    <p class="user_name ari_font">{{i.bank}}</p>
                    <p class="user_num">{{i.user}}</p>
                </div>
                <div class="del" @click="delCard(i.id)">
                    <i class="iconfont icon-huishouzhan_huaban"></i>
                </div>
            </div>
            <div style="height: 10px;"></div>
        </div>
        <div class="basic_btn" @click.stop="$router.push('/addcountUsdt')">{{$t('account.addAccount')}}</div>
    </div>
</template>

<script>
    import Fetch from '../../utils/fetch'
    import { Dialog } from 'vant';

    export default {
        name: "account",
        data() {
            return {
                allNum:0,
                data: {}
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.start();
        },
        methods: {
            delCard(id){
                Dialog.confirm({
                    message:this.$t('del'),
                    confirmButtonText:this.$t('utils.confirm'),
                    cancelButtonText:this.$t('utils.cancel')
                })
                .then(() => {
                    Fetch('/user/bank_remove', {id: id}).then(() => {
                        this.start()
                    });
                })
                .catch(() => {
                    // on cancel
                });
               
            },
            start(){
                Fetch('/user/my_bank').then(r=>{
                    this.data = r.data;
                    this.allNum = r.data.count;
                })
            }
        }
    };
</script>

<style lang="less" scoped>
    .red_top_bg {
        position: relative;
    }
	.back_left {
		background: url(../../views/images/item/back_b.png) no-repeat center center;
	}
	.big_tit{
		color: #000000;
	}
    .recharge_wrap {
        background-image: linear-gradient(90deg, #0d3a32, #082820 55%, #051a15);
        min-height: 100dvh;
    }
    .warp1 {
        padding: 0 20px;
        height: 40px;

        p {
            font-size: 14px;
            line-height: 40px;
            color: #eeeeee;
            font-weight: bold;

            span {
                color: #F03041;
            }
        }
    }

    .ari_font {
        height: 20px;
        font-size: 14px;
        font-weight: 600;
        color:#ffffff;
        line-height: 20px;
    }

    .warp2 {
        margin-top: 12px;

        .item {
            padding: 14px 10px 11px 10px;
            margin-bottom: 10px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            background: #0e3f33;
            justify-content: flex-start;
            border: 1px solid rgb(186, 192, 198);

            &:last-child {
                border-bottom: none;
            }

            img {
                width: 30px;
                height: 30px;
            }

            .item_name {
                width: 65px;
            }
			.item_detail{
				margin-left: 10px;
			}

            .user_num {
                height: 17px;
                font-size: 12px;
                font-weight: 600;
                color: #eeeeee;
                line-height: 17px;
                margin-top: 10px;
            }

            .del {
                width: 20px;
                height: 20px;
                // background: url(../images/item/del.png) no-repeat center center;
                display: flex;
                align-items: center;
                justify-content: center;
                background-size: 100% 100%;
                margin: 0 8px 0 auto;
                .iconfont {
                    color: #fff;
                    font-size:20px;
                }
            }
        }
    }

    .basic_btn {
        margin: 50px auto 0 auto;
    }

    .wrap_box {
	width: 92%;
	background: none;
	margin: 20px auto 0px auto;
	padding-bottom: 10px;
	box-shadow: none;
    color:#eeeeee;
}

.title-box {
	width: 100%;
	display: flex;
	align-items: center;
	padding: 15px;
	height: 60px;
	position: sticky;
	top: 0px;
	z-index: 10;
	background: #072B22;
	border-bottom: 1px solid #265245;

	h2 {
		color: #E6F7EF;
		margin-left: 10px;
	}

	.btn,
	.back {
		height: 32px;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid #375852;
		border-radius: 12px;
		padding: 8px 9px;
		color: #fff;
		margin-left: auto;
		background: none;

		.iconfont {
			font-size: 18px;
		}
	}

	.back {
		margin-left: 0px;
	}
}
</style>
